export const AW_COMMENTARY_API_URL = process.env?.AWAPI_COMMENTARY_URL || '/api/wealth/analytics/commentary';
